import React, { Component } from "react"
import { Button, FormControl, Modal, OverlayTrigger, Tooltip } from "react-bootstrap"
import Select from "react-select"
import states from "src/utilities/States/states"
import EmployeeDataTypes from "../../../../../Types/EmployeeTypes"
import ReferenceTypes from "../../../../../Types/ReferenceTypes"
import "./EditAddress.css"

interface PhysicalAddressProps {
    employee: EmployeeDataTypes
    copy: EmployeeDataTypes
    appendParams: Function
    reference: ReferenceTypes
    toggleEditAddress: Function
}

type PhysicalAddressTypes = {
    isDirty: boolean
    eventType: string
}

class PhysicalAddress extends Component<PhysicalAddressProps, PhysicalAddressTypes> {

    state = {
        isDirty: false,
        eventType: ""
    }

    setEventType = (type: string) => {
        this.setState({ eventType: type })
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        let employee = this.props.employee
        let eventType = this.state.eventType
        let eventTypes = Object.keys(employee)
        let temp: any = employee
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.props.appendParams([param])
            }
        }
        this.checkIfDirty()
    }

    save = () => {
        this.props.toggleEditAddress("editPhysicalAddress")
    }


    clear = () => {
        this.props.appendParams([{ Address1: null }, { Address2: null }, { City: null }, { State: null }, { ZipCode: null }])
        this.checkIfDirty()
    }

    undo = () => {
        this.props.appendParams([{ Address1: this.props.copy.Address1 }, { Address2: this.props.copy.Address2 }, { City: this.props.copy.City }, { State: this.props.copy.State }, { ZipCode: this.props.copy.ZipCode }])
        this.props.toggleEditAddress("editPhysicalAddress")
    }

    checkIfDirty = () => {
        let employee = this.props.employee
        let copy = this.props.copy
        let a = JSON.stringify({ a: employee.Address1, b: employee.Address2, c: employee.City, d: employee.State, e: employee.ZipCode })
        let b = JSON.stringify({ a: copy.Address1, b: copy.Address2, c: copy.City, d: copy.State, e: copy.ZipCode })
        if (a !== b) {
            this.setState({ isDirty: true })
        } else {
            this.setState({ isDirty: false })
        }
    }

    render() {

        const ClearAllTooltip = (
            <Tooltip id="uac-tool-tip">
                Clear all fields
            </Tooltip>
        )

        return (
            <div className="PhysicalAddress">
                <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="EditAddressModalHeader">
                            <p>Physical Address</p>
                            <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={ClearAllTooltip}>
                                <span id="edit-address-clear-btn" className="material-icons" onClick={() => this.clear()}>clear_all</span>
                            </OverlayTrigger>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="UACAddressR1">
                            {this.props.employee.Address1 && <div id="uac-filled-field"><p>Address Line 1<span className="material-icons">done</span></p></div>}
                            {!this.props.employee.Address1 && <div id="uac-missing-field"><p>Address Line 1<span className="material-icons">warning</span></p></div>}
                            <FormControl
                                onFocus={() => this.setEventType("Address1")}
                                placeholder={this.props.employee.Address1 || "*NA*"}
                                onChange={this.handleChange}
                                value={this.props.employee.Address1 || ""}
                            />
                            <div id="uac-filled-field"><p>Address Line 2</p></div>
                            <FormControl
                                onFocus={() => this.setEventType("Address2")}
                                placeholder={this.props.employee.Address2 || "*NA*"}
                                onChange={this.handleChange}
                                value={this.props.employee.Address2 || ""}
                            />
                        </div>
                        <div className="UACAddressR2">
                            <div className="UACAddressR2Column">
                                {this.props.employee.City && <div id="uac-filled-field"><p>City<span className="material-icons">done</span></p></div>}
                                {!this.props.employee.City && <div id="uac-missing-field"><p>City<span className="material-icons">warning</span></p></div>}
                                <FormControl
                                    onFocus={() => this.setEventType("City")}
                                    placeholder={this.props.employee.City || "*NA*"}
                                    onChange={this.handleChange}
                                    value={this.props.employee.City || ""}
                                />
                            </div>
                            <div className="UACAddressR2Column" id="uac-address-r2-middle-column">
                                {this.props.employee.State && <div id="uac-filled-field"><p>State<span className="material-icons">done</span></p></div>}
                                {!this.props.employee.State && <div id="uac-missing-field"><p>State<span className="material-icons">warning</span></p></div>}
                                {this.props.reference.allStates &&
                                    <Select
                                        //@ts-ignore
                                        value={{ label: this.props.employee.State || "*NA*" }}
                                        options={states.map((s: any) => ({ value: s.StateID, label: s.StateName, code: s.StateCode }))}
                                        onChange={(item: any) => {
                                            this.props.appendParams([{ State: item.code }])
                                            this.checkIfDirty()
                                        }}
                                        // menuPlacement="top"
                                        maxMenuHeight={300}
                                    />}
                            </div>
                            <div className="UACAddressR2Column">
                                {this.props.employee.ZipCode && <div id="uac-filled-field"><p>Zip Code<span className="material-icons">done</span></p></div>}
                                {!this.props.employee.ZipCode && <div id="uac-missing-field"><p>Zip Code<span className="material-icons">warning</span></p></div>}
                                <FormControl
                                    onFocus={() => this.setEventType("ZipCode")}
                                    placeholder={this.props.employee.ZipCode || "*NA*"}
                                    onChange={this.handleChange}
                                    value={this.props.employee.ZipCode || ""}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="EditAddressModalFooter">
                            <Button variant="secondary" onClick={() => this.undo()}>Cancel</Button>
                            <Button variant="primary" disabled={!this.state.isDirty} onClick={() => this.save()}>Ok</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default PhysicalAddress